/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { useDispatch } from 'react-redux';
import { View, TouchableOpacity, ScrollView } from 'react-native';
import { isWeb, fullWidth } from '@/global/screens';
import Colors from '@/global/colors';
import Image from '@components/global/Image';
import ModalImage from '@components/modal/ModalImage';
import TitleSubSection from '@components/global/TitleSubSection';
import SociollaText from '@components/sociolla/SociollaText';

const widthContainer = isWeb ? '100%' : fullWidth - 30;
const photoSize = isWeb ? 140 : (widthContainer - 70) / 2;

import { showImage } from '@/store/global';

// eslint-disable-next-line react/prop-types
const TodoListEngage = ({ detailTodos = [] }) => {
  const dispatch = useDispatch();
  // NPD Presentation (Visit Report)
  const dataNpsPresentation = detailTodos.find(
    (a) => a.target_type == 'npd_presentation',
  );
  let notes = [];
  let plan_npd = [];
  if (dataNpsPresentation) {
    const detailNotes = dataNpsPresentation.more_info || {};
    notes = detailNotes.notes?.length
      ? detailNotes.notes.filter((a) => a.type == 'npd_presentation')
      : [];

    const detailPlan = dataNpsPresentation.more_info || {};
    plan_npd = detailPlan.plan_for_next_visit?.length
      ? detailPlan.plan_for_next_visit.filter(
          (a) => a.type == 'npd_presentation',
        )
      : [];
  }

  // Share Photo
  const dataSharePhoto = detailTodos.find(
    (a) => a.target_type == 'upload_store_photo',
  );
  let images = [];
  if (dataSharePhoto) {
    const detailImage = dataSharePhoto.more_info || {};
    const store = detailImage.attachments?.length
      ? detailImage.attachments.find((a) => a.type == 'store')
      : [];
    images = store?.image?.length ? store.image.map((a) => a.url) : [];
  }

  const PhotoCard = ({ url, index }) => (
    <TouchableOpacity
      testID={`todo-engage-photo-${index}`}
      onPress={() => {
        dispatch(
          showImage({
            isModal: true,
            disableCDN: true,
            isMultiple: true,
            allImage: [url],
            url: url || '',
            noArrow: true,
          }),
        );
      }}
      activeOpacity={0.6}
      style={{
        width: photoSize,
        height: photoSize,
        borderRadius: 5,
        overflow: 'hidden',
        marginRight: 10,
      }}>
      <Image
        style={{ width: photoSize, height: photoSize }}
        width={photoSize}
        height={photoSize}
        source={url || ''}
        disableCDN={true}
      />
    </TouchableOpacity>
  );

  const EmptyState = () => (
    <View
      style={{
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 30,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: Colors.grey0,
        borderStyle: 'dashed',
      }}>
      <Image
        style={{ width: 40, height: 40, marginBottom: 10, opacity: 0.5 }}
        width={40}
        height={40}
        svg={true}
        source={require('@assets/img/icons/gallery-grey.svg')}
      />
      <SociollaText
        style={{
          fontSize: 12,
          color: Colors.grey2,
          textAlign: 'center',
        }}>
        No store photos available
      </SociollaText>
    </View>
  );

  return (
    <View testID="todo-engage-container" style={{ width: '100%' }}>
      <TitleSubSection title="VISIT REPORT" />
      <View style={{ width: '100%', padding: 15 }}>
        <SociollaText style={{ fontSize: 13, marginBottom: 10 }}>
          Visit Report
        </SociollaText>
        {notes?.length ? (
          notes.map((item, idx) => (
            <React.Fragment key={`note-${idx}`}>
              {isWeb ? (
                <SociollaText style={{ fontSize: 13 }}>
                  {item.text || '-'}
                </SociollaText>
              ) : (
                <View
                  style={{
                    width: '100%',
                    backgroundColor: Colors.grey0,
                    borderRadius: 5,
                    padding: 10,
                    marginBottom: 10,
                  }}>
                  <SociollaText style={{ fontSize: 13 }}>
                    {item.text || '-'}
                  </SociollaText>
                </View>
              )}
            </React.Fragment>
          ))
        ) : (
          <SociollaText style={{ fontSize: 13 }}>-</SociollaText>
        )}
      </View>
      <View style={{ width: '100%', padding: 15 }}>
        <SociollaText style={{ fontSize: 13, marginBottom: 10 }}>
          Plan for Next Visit
        </SociollaText>
        {plan_npd?.length ? (
          plan_npd.map((item, idx) => (
            <React.Fragment key={`plan-${idx}`}>
              {isWeb ? (
                <SociollaText style={{ fontSize: 13 }}>
                  {item.text || '-'}
                </SociollaText>
              ) : (
                <View
                  style={{
                    width: '100%',
                    backgroundColor: Colors.grey0,
                    borderRadius: 5,
                    padding: 10,
                    marginBottom: 10,
                  }}>
                  <SociollaText style={{ fontSize: 13 }}>
                    {item.text || '-'}
                  </SociollaText>
                </View>
              )}
            </React.Fragment>
          ))
        ) : (
          <SociollaText style={{ fontSize: 13 }}>-</SociollaText>
        )}
      </View>
      <TitleSubSection title="STORE PHOTO" />
      <View
        style={{
          width: '100%',
          backgroundColor: Colors.grey3,
          padding: 20,
        }}>
        <View
          style={{
            backgroundColor: Colors.white,
            borderRadius: 12,
            padding: 20,
            elevation: 5,
            borderLeftWidth: 5,
            borderLeftColor: Colors.blue4,
          }}>
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: 15,
              paddingBottom: 15,
              borderBottomWidth: 1,
              borderBottomColor: Colors.grey0,
            }}>
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <View
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 18,
                  backgroundColor: Colors.blue9,
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: 12,
                }}>
                <Image
                  style={{ width: 18, height: 18 }}
                  width={18}
                  height={18}
                  svg={true}
                  source={require('@assets/img/icons/gallery-grey.svg')}
                />
              </View>
              <View>
                <SociollaText
                  type="medium"
                  style={{ fontSize: 14, color: Colors.black3 }}>
                  Store Photos
                </SociollaText>
                <SociollaText
                  style={{ fontSize: 11, color: Colors.grey2, marginTop: 2 }}>
                  {images?.length ? `${images.length} Photos` : 'No photos'}
                </SociollaText>
              </View>
            </View>
          </View>

          {images?.length ? (
            <ScrollView horizontal showsHorizontalScrollIndicator={false}>
              {images.map((img, idx) => (
                <PhotoCard url={img} index={idx} key={idx} />
              ))}
            </ScrollView>
          ) : (
            <EmptyState />
          )}
        </View>
      </View>
      <ModalImage />
    </View>
  );
};

export default React.memo(TodoListEngage, (prev, next) => prev == next);
